export default __webpack_public_path__ + "static/media/icon-event-cabinet.77f87082.svg";